import React from "react"
import VideoPlayer from "../../pages/videoPlayer"
import NiradhiVideo from "../../images/niradhi/video.mp4"

const Video = () => {
  return (
    <div className="w-100 additional-top-padding">
      <VideoPlayer data={NiradhiVideo} />
    </div>
  )
}

export default Video
